import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { DashboardAlert } from '@/types/dashboard';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  data: DashboardAlert;
};

type Response = DashboardAlert;

const validate = (data: DashboardAlert) => {
  if (!data.message) {
    throw new Error('`message` is required');
  }
};

export const createDashboardAlert = async ({ data }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    validate(data);

    const result = await scopedApi(GLOBAL_SCOPE).post<EndpointResponse<Response>>('dashboard_alert', data, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
